export enum ReactIntegrationMode {
    'VOA' = 'VOA',
    'AC' = 'AC',
    'VSE' = 'VSE'
}
